import { Fragment } from "react";
import AvalilableMeals from "./AvalilableMeals";
import MealsSummary from "./MealsSummary";

const Meals = () =>{
    return<Fragment>
        <MealsSummary/>
        <AvalilableMeals/>
    </Fragment>
}

export default Meals;